import type { JSX } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { FormSectionProps } from './types';

export function DatesSection({ register, errors }: FormSectionProps): JSX.Element {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Important Dates</h3>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="jobPostingDate">Job Posting Date *</Label>
          <Input id="jobPostingDate" type="date" {...register('jobPostingDate')} />
          {errors.jobPostingDate && (
            <p className="text-sm text-red-500">{errors.jobPostingDate.message}</p>
          )}
        </div>
        <div className="space-y-2">
          <Label htmlFor="applicationDeadline">Application Deadline *</Label>
          <Input id="applicationDeadline" type="date" {...register('applicationDeadline')} />
          {errors.applicationDeadline && (
            <p className="text-sm text-red-500">{errors.applicationDeadline.message}</p>
          )}
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="startDate">Start Date</Label>
        <Input id="startDate" type="date" {...register('startDate')} />
        {errors.startDate && <p className="text-sm text-red-500">{errors.startDate.message}</p>}
      </div>
    </div>
  );
}
